module.exports = __webpack_public_path__ + "img/arrow-up-icon-23.1f7d00fc.png";